import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { LrsService, LbLrs } from './lrs.service';

@Injectable()
export class ResolverLbeLrsService implements Resolve<LbLrs[]> {

	constructor(
		private lrsService: LrsService
	) { }

	async resolve(): Promise<LbLrs[]> {
		const lrsData = await new Promise<LbLrs[]> ((resolve, reject) => {
			try {
				this.lrsService.getLrs((rsp) => {
					resolve(rsp);
				}, (error) => {
					resolve([]);
					console.log('Failed to get lrs');
				});
			} catch (err) {
				console.log('Failed to get lrs');
				resolve([]);
			}
		});
		return lrsData;
	}

}



// WEBPACK FOOTER //
// ./src/app/common-services/resolver-lbe-lrs.service.ts